export default __webpack_public_path__ + "static/media/36I-102611_-17683_0.595bd58a.jpg";